export default "__VITE_ASSET__BxVwBwMu__"